import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsHasUserInsuranceParams,
  GetMarathonsHasUserInsuranceResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathonsHasUserInsurance = createAsyncThunk<
  GetMarathonsHasUserInsuranceResponse,
  GetMarathonsHasUserInsuranceParams
>(
  "marathons/getMarathonsHasUserInsurance",
  async (params, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonsHasUserInsurance(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting marathons has user insurance",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while getting marathons has user insurance",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
